<template>
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Category</th>
        <th>Business Plan</th>
        <th>Actual</th>
        <th>Difference</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>Avg Sales Price</strong></td>
        <td>{{ economicModel.avg_sale_price | currency }}</td>
        <td>{{ items.avg_sale_price | currency }}</td>
        <td>{{ items.avg_sale_price - economicModel.avg_sale_price | currency }}</td>
      </tr>
      <tr>
        <td><strong>Avg GCI %</strong></td>
        <td>{{ economicModel.avg_commission_percent }}%</td>
        <td>{{ (items.avg_commission_percent).toFixed(2) }}%</td>
        <td>{{ (items.avg_commission_percent - economicModel.avg_commission_percent).toFixed(2) }}%</td>
      </tr>
      <tr>
        <td><strong>Listing Taken %</strong></td>
        <td>{{ economicModel.listings_taken_percent }}%</td>
        <td>{{ (items.listings_taken_percent).toFixed(2) }}%</td>
        <td>{{ (items.listings_taken_percent - economicModel.listings_taken_percent).toFixed(2) }}%</td>
      </tr>
      <tr>
        <td><strong>Listings Taken to Close %</strong></td>
        <td>{{ economicModel.listings_taken_to_close }}%</td>
        <td>{{ (items.closed_percent).toFixed(2) }}%</td>
        <td>{{ (items.closed_percent - economicModel.listings_taken_to_close).toFixed(2) }}%</td>
      </tr>
      <tr>
        <td><strong>% of Business From Listings</strong></td>
        <td>{{ economicModel.percent_of_business }}%</td>
        <td>{{ (items.percent_of_business).toFixed(2) }}%</td>
        <td>{{ (items.percent_of_business - economicModel.percent_of_business).toFixed(2) }}%</td>
      </tr>
      <tr>
        <td><strong>Monthly Expenses Average</strong></td>
        <td>{{ cos.monthly_expenses | currency }}</td>
        <td>{{ items.expense_total | currency }}</td>
        <td>{{ cos.monthly_expenses - items.expense_total | currency }}</td>
      </tr>
      <tr>
        <td><strong>Cost of Sale</strong></td>
        <td>{{ cosPercent }}%</td>
        <td>{{ (items.cos_percent).toFixed(2) }}%</td>
        <td>{{ (items.cos_percent - cosPercent).toFixed(2) }}%</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    items: null,
    economicModel: null,
    cos: null,
    cosPercent: null
  }
};
</script>